/**
 * Type guard function that checks if a value is an array.
 * Returns true if the value is an array, false otherwise.
 *
 * @param arg - The value to check
 * @returns True if the value is an array, false otherwise
 *
 * @example
 * ```ts
 * import { ArrayQ } from "@pdfking/structs"
 *
 * ArrayQ([1, 2, 3]) // true
 * ArrayQ("hello") // false
 *
 * // Use in conditional logic
 * const input: string | string[] = "hello"
 * ArrayQ(input) ? input : [input] // ["hello"]
 * ```
 */
export const ArrayQ = Array.isArray
